import type { KeyboardSettings } from '@amit/types';

type defaultNodeType = 'heading' | 'headline' | 'paragraph';

export interface HeadlineOptions {
  defaultNode: defaultNodeType;
  maxLength: number | null;
  sizeBreakpoint: number;
  keyboardSettings: KeyboardSettings;
  fontSize: string;
  textAlign: string;
  zoom: number;
  level: number;
  allowEnter: boolean;
  maxLines: number | null;
  lineHeight: number;
}

export const createDefaultOptions = (
  isMathCourse: boolean = false,
): HeadlineOptions => ({
  defaultNode: 'paragraph',
  maxLength: null,
  sizeBreakpoint: 50,
  keyboardSettings: {
    showMathmaticalKeyboard: isMathCourse,
    keyboardList: ['FULL', 'numeric', 'symbols', 'alphabetic'],
  },
  level: 3,
  fontSize: '18px',
  textAlign: 'inherit',
  zoom: 100,
  allowEnter: true,
  maxLines: null,
  lineHeight: 1.2,
});
